import { type ReactNode } from "react";

export function Panel({
  action,
  children,
  title,
}: {
  action?: ReactNode;
  children: ReactNode;
  title: string;
}) {
  return (
    <section className="mb-8 rounded-lg border border-black/10 bg-white">
      <div className="flex items-center gap-4 border-b border-black/10 px-5 py-3">
        <h2 className="font-semibold">{title}</h2>
        {action ? <div className="ml-auto">{action}</div> : null}
      </div>
      <div className="px-5 py-4">{children}</div>
    </section>
  );
}

export function Empty({ children }: { children: ReactNode }) {
  return <p className="py-6 text-center text-sm text-ink/50">{children}</p>;
}

export function Failure({ children }: { children: ReactNode }) {
  return (
    <p className="rounded border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-800">
      {children}
    </p>
  );
}
